var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.inCart)?_c('nuxt-link',{staticClass:"btn buyed red",attrs:{"to":"/personal/cart/"}},[_vm._v("В корзине")]):_c('btn',{staticClass:"buy-btn",attrs:{"loading":_vm.buying},on:{"click":_vm.buy}},[_vm._v("\n        В корзину\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }